/*
 *  Product Carousel
 *    Scripts for the product carousel utilising Slick.
 *
 *
 *  Version:
 *    1.0.0 - 2019/05/06
 */

import $ from 'jquery';
import { pictureGenerate } from '@process-creative/slate-theme-tools';

import { CarouselSection } from './../carousel/CarouselSection';
import { ON_VARIANT_CHANGE } from './../../objects/swatch/Swatch';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-product-carousel-container]';
export const CAROUSEL_SELECTOR = '[data-product-carousel]';
export const CAROUSEL_NAVIGAITON_SELECTOR = '[data-product-carousel-navigation]';
export const CAROUSEL_DOTS_SELECTOR = '[data-product-carousel-dots]';
export const CAROUSEL_DOT_SELECTOR = '[data-product-carousel-dot]';
export const PRODUCT_JSON_SELECTOR = '[data-product-json]';
export const PRODUCT_IMAGE_SELECTOR = '[data-product-template-carousel-image]';
export const PRODUCT_THUMBNAIL_SELECTOR = '[data-product-template-thumbnail-image]';
export const PRODUCT_THUMBNAIL_LIGHTBOX = '[data-product-image-lightbox]';
export const PRODUCT_IMAGE_MAGNIFY_IMAGE_SELECTOR = '[data-hover-magnify-image]';
export const PRODUCT_LIGHTBOX_WRAPPER = '[data-product-lightbox-wrapper]';
const PRODUCT_VIDEO_PLAY = '[data-product-template-video-play]';
const PRODUCT_VIDEO = '[data-product-template-video]';

export const PRODUCT_FOTORAMA_GALLERY_CONTAINER_SELECTOR = '[data-fotorama-gallery-container]';
export const PRODUCT_FOTORAMA_GALLERY_SELECTOR = '[data-fotorama-gallery]';

//Attrs
export const THUMBNAIL_INDEX = 'data-index';
export const PRODUCT_INITIAL_VARIANT = 'data-initial-variant-id';
export const PRODUCT_DATA_LIGHTBOX = 'data-product-image-lightbox';
export const PRODUCT_DATA_IMAGE_MAGNIFY_IMAGE_SELECTOR = 'data-hover-magnify-image';
export const PRODUCT_DATA_LIGHTBOX_WRAPPER = 'data-product-lightbox';

export const THUMBNAIL_SELECTOR = '[data-product-template-thumbnail-image]';

export const CLASS_MAGNIFIED = 'is-magnified';
export const CLASS_OPEN = 'is-open';
export const CLASS_PLAYING = 'is-playing';

export class ProductCarousel extends CarouselSection {
  constructor(container) {
    super(container);

    this.container = container;
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    this.navigation = container.find(CAROUSEL_NAVIGAITON_SELECTOR);
    this.navigationDots = container.find(CAROUSEL_DOT_SELECTOR);

    //JSON Data
    this.jsonElement = $(PRODUCT_JSON_SELECTOR);

    this.slick = this.initCarousel(this.carouselContainer);
    this.productThumb = container.find(PRODUCT_THUMBNAIL_SELECTOR);
    this.productTitle = container.attr('data-product-title');

    //Events
    this.container.on('click', THUMBNAIL_SELECTOR, (e) => this.onThumbnailClick(e));
    this.container.on('click', CAROUSEL_DOT_SELECTOR, (e) => this.onDotClick(e));
    this.container.on('click', PRODUCT_THUMBNAIL_LIGHTBOX, (e) => this.onClickLightbox(e));
    this.container.on('click', PRODUCT_VIDEO_PLAY, (e) => this.onClickCarouselVideo(e));

    // this.container.on('mouseup', (e) => this.onFocusOut(e));

    $(document).on(ON_VARIANT_CHANGE, (e,variant) => this.onVariantChange(variant));

    container.on('beforeChange', (e, slick, currentSlide, nextSlide) => this.onSlickChange(e, slick, currentSlide, nextSlide));

    this.container.on('mouseover', PRODUCT_IMAGE_MAGNIFY_IMAGE_SELECTOR, (e) => this.onMouseOver(e));
    this.container.on('mousemove', PRODUCT_IMAGE_MAGNIFY_IMAGE_SELECTOR, (e) => this.onMouseMove(e));
    this.container.on('mouseout', PRODUCT_IMAGE_MAGNIFY_IMAGE_SELECTOR, (e) => this.onMouseOut(e));

    this.initNavCarousel();//Initialise navigation slick
    this.initVariantImage();//Initialise variant image

    //reinitialise the carousel after image loaded when chhose a different variant
    // this.carouselContainer.find(PRODUCT_IMAGE_SELECTOR+' img').each((i,e) => {
    //   e.addEventListener('load', () => {
    //     this.carouselContainer.slick('slickSetOption', 'reinit', true, true);
    //   });
    // });


    // Fotorama
    this.fotoramaGalleryContainer = $(PRODUCT_FOTORAMA_GALLERY_CONTAINER_SELECTOR);
    this.fotoramaGallery = this.fotoramaGalleryContainer.find(PRODUCT_FOTORAMA_GALLERY_SELECTOR);
    this.fotoramaGallery.fotorama();

    if (!this.fotoramaGallery) {
      console.error(`Fotorama gallery is not defined.`);
      return;
    }

    this.fotoramaGallery.on('fotorama:fullscreenenter', () => {
      this.fotoramaGalleryContainer.removeClass('is-hidden');
    });
    this.fotoramaGallery.on('fotorama:fullscreenexit', () => {
      this.fotoramaGalleryContainer.addClass('is-hidden');
    });

    this.fotorama = this.fotoramaGallery.data('fotorama');

    this.fotorama.setOptions({
      width: 700,
      maxwidth: '100%',
      nav: 'dots',
      navposition: 'bottom',
      thumbwidth: '100',
      thumbborderwidth: 2,
      arrows: true,
      allowfullscreen: true,
      ratio: 16/9
    });

    container.on('afterChange', (e, slick, currentSlide) => {
      this.fotorama.show(currentSlide);
    });

  }

  onFocusOut(e) {
    let inner = this.container.find(PRODUCT_LIGHTBOX_WRAPPER);
    let box = this.container.find('['+PRODUCT_DATA_LIGHTBOX_WRAPPER+']')

    if (!inner.is(e.target) // if the target of the click isn't the container...
    && inner.has(e.target).length === 0) // ... nor a descendant of the container
    {
      box.removeClass(CLASS_OPEN);
    }
  }
  onMouseOver(e) {
    if($(window).width() < ResponsiveSizes.medium ) return;
    let magnifiedImage = this.container.find(e.target);
    magnifiedImage.addClass(CLASS_MAGNIFIED);
  }

  onMouseMove(e) {
    let magnifiedImage = this.container.find(e.target);
    if(!magnifiedImage) return;
    let magnifiedImageContainer = magnifiedImage.closest('['+PRODUCT_DATA_LIGHTBOX_WRAPPER+']');
    let offset = magnifiedImageContainer.offset();
    let posX = (e.pageX - offset.left) * 100 / magnifiedImageContainer.innerWidth();
    let posY = (e.pageY - offset.top) * 100 / magnifiedImageContainer.innerHeight();
    magnifiedImage.css('transform-origin', `${parseFloat(posX)}% ${parseFloat(posY)}%`);
  }

  onMouseOut(e) {
    let magnifiedImage = this.container.find(e.target);
    if(!magnifiedImage) return;
    $(PRODUCT_IMAGE_MAGNIFY_IMAGE_SELECTOR).removeClass(CLASS_MAGNIFIED)
    magnifiedImage.css('transform-origin', '0% 0%');
  }

  onClickLightbox(e){
    e.preventDefault();
    e.stopPropagation();

    this.fotorama.requestFullScreen();

    return;
  }

  initNavCarousel() {
    if (this.productThumb.length < 4) return this.navigationSlick = null;
    this.navigationSlick = this.navigation.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      dots: false,
      arrows: true,
      focusOnSelect: true,
      centerMode: false,
      vertical: true,
      verticalSwiping: true,
      draggable: true,
      adaptiveHeight: false,
      swipeToSlide: true
    });
  }

  initVariantImage() {
    //Set the thumb and main image on page load
    let initial = this.carouselContainer.attr(PRODUCT_INITIAL_VARIANT);
    if(!this.jsonElement.length || !initial) return;
    let data = JSON.parse(this.jsonElement.html());

    for(let i = 0; i < data.variants.length; i++) {
      let v = data.variants[i];
      if (v.id == initial) {
        this.onVariantChange(v);
        break;
      }
    }
    // let thumbTarget = $(PRODUCT_THUMBNAIL_SELECTOR+'[data-image-id="'+initial+'"]');
    // let mainTarget = $(PRODUCT_IMAGE_SELECTOR+'[data-image-id="'+initial+'"]');

    // console.log(mainTarget);
    // if (this.navigationSlick) {
    //   this.navigationSlick.slick('slickGoTo', parseInt(thumbTarget.attr(THUMBNAIL_INDEX)), false);
    // }
    // this.slick.slick('slickGoTo', parseInt(mainTarget.attr(THUMBNAIL_INDEX)), false);
  }

  onSlickChange(e, slick, currentSlide, nextSlide) {
    this.navigationDots.removeClass('is-active');
    $(this.navigationDots[nextSlide]).addClass('is-active');
    let video = this.carouselContainer.find(`${PRODUCT_VIDEO_PLAY}[data-index=${nextSlide}]`);
    if (video[0]) {
      video.find(PRODUCT_VIDEO)[0].currentTime = 0;
      video.find(PRODUCT_VIDEO)[0].play();
      video.addClass(CLASS_PLAYING);

    }
  }

  onClickCarouselVideo(e) {
    e.preventDefault();
    if(!$(e.currentTarget).find(PRODUCT_VIDEO)[0]) return;

    if($(e.currentTarget).find(PRODUCT_VIDEO)[0].paused) {
      $(e.currentTarget).addClass(CLASS_PLAYING);
      $(e.currentTarget).find(PRODUCT_VIDEO)[0].play();
    } else {
      $(e.currentTarget).removeClass(CLASS_PLAYING);
      $(e.currentTarget).find(PRODUCT_VIDEO)[0].pause();
    }
  }

  // setBoundries(slick, state) {
  //   if(state === 'default') {
  //     this.container.find('ul.slick-dots li.slick-active').eq(4).addClass('n-small-1');
  //   }
  // }

  optionOverrides() {
    return {
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      cssEase: 'linear',
      dots: false,
      adaptiveHeight: true,
      swipe: true,
      focusOnSelect: true,
      infinite: false,
      responsive: [
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 1, slidesToScroll: 1, dots: false }
        }
      ]
    }
  }

  onDotClick(e) {
    let self = $(e.currentTarget);
    let index = self.attr('data-index');
    this.goToSlide(index);
  }

  //Thumbnail Navigation
  onThumbnailClick(e) {
    let self = $(e.currentTarget);
    let index = self.attr('data-index');
    this.goToSlide(index);
  }

  onVariantChange(variant) {
    if(typeof variant === typeof undefined) return;

    if(!this.jsonElement.length) return;
    let data = JSON.parse(this.jsonElement.html());

    //Find the colour index from variant options.
    let colourIndex;
    for(let i = 0; i < data.options.length; i++) {
      if(data.options[i].toLowerCase() == 'color' || data.options[i].toLowerCase() == 'colour') {
        colourIndex = i;
        break;
      }
    }

    if(variant.options[colourIndex]) {
      let variantName = variant.options[colourIndex].toLowerCase();

      ///Find a variant matching this name with an image.
      let defaultColourImg = null;
      for(let i = 0; i < data.variants.length; i++) {
        let v = data.variants[i];
        if(v.options[colourIndex].toLowerCase() != variantName) continue;
        if(!v.featured_media || !v.featured_media.id) continue;
        defaultColourImg = v.featured_media.id;
        break;
      }

      //Set our image, use the one for this variant, if not use default.
      if(variant.featured_media) {
        let mediaId = variant.featured_media.id;
        let target = $(PRODUCT_THUMBNAIL_SELECTOR+'[data-image-id='+mediaId+']');
        if (this.navigationSlick) {
          this.navigationSlick.slick('slickGoTo', parseInt(target.attr(THUMBNAIL_INDEX)));
        }
        target.trigger('click');
      }

      if(!variant.featured_media && defaultColourImg) {
        let mediaId = defaultColourImg;
        let target = $(PRODUCT_THUMBNAIL_SELECTOR+'[data-image-id='+mediaId+']');
        target.trigger('click');
      }
    }
  }

  goToSlide(index) {
    this.carouselContainer.slick('slickGoTo', index);
    this.setActiveImage(index);
  }

  setActiveImage(index) {
    $(THUMBNAIL_SELECTOR).removeClass('is-active');
    $(`${THUMBNAIL_SELECTOR}[data-index="${index}"]`).addClass('is-active');
  }

  onImageSlideChange(toSlide) {
    this.setActiveImage(toSlide);
  }

  onThumbnailSlideChange(toSlide) {
    this.carouselContainer.slick('slickGoTo', toSlide);
    this.setActiveImage(toSlide);
  }

}

register(CONTAINER_SELECTOR, ProductCarousel);
